<template>

<app-table empty-message="This attendee has not purchased any badges or items." :empty="!items.length">

	<app-table-head :layout="layout">
	
		<app-table-column />

		<app-table-column text="Name" />

		<app-table-column text="Type" />

		<app-table-column text="Public No." align="center" />

		<app-table-column text="Method" align="center" />

		<app-table-column text="Created on" align="center" />

	</app-table-head>

	<app-table-body>

		<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in items" :key="item.id">

			<app-table-cell-label :text="$constants.badge.statusName[item.status]" :type="$constants.badge.statusTheme[item.status]" :subtext="item.reference" />

			<app-table-cell-text :text="item.name" :subtext="(item.group) ? item.group.name : false" />

			<app-table-cell-text :text="item.type.name" />

			<app-table-cell-text :text="item.referenceRandom" align="center" />

			<app-table-cell-text :text="$constants.badge.methodName[item.method]" align="center" />

			<app-table-cell-text :text="item.date | localDate('DD MMMM YYYY')" align="center" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['items'],

	data: function() {
	
		return {
			layout: '120px 1fr 240px 120px 120px 120px'
		}
	
	},

	methods: {
	
		onEditClick: function(id) {
		
			this.$router.push({
				name: 'Convention.Badges.Holders.Edit', 
				params: {
					id: id
				}
			})
		
		}
	
	}

}

</script>

<style scoped>

</style>